import React from 'react';
import { IMAGE_PATHS } from '../config/images';

const SYMPTOMS = [
  {
    id: 1,
    icon: 'fa-person',
    title: 'Vergonha do corpo',
    text: 'Evita praia, foto, roupa justa e situações onde precisa expor o corpo por não se sentir bem consigo mesmo.'
  },
  {
    id: 2,
    icon: 'fa-weight-scale',
    title: 'Tenta emagrecer mas não vê o resultado que gostaria',
    text: 'Fez dieta, mudou a alimentação, começou uma nova rotina… mas olha para o espelho ou para a balança e sente que seu esforço nunca é recompensado.'
  },
  {
    id: 3,
    icon: 'fa-brain',
    title: 'Ansiedade, estresse e compulsão alimentar',
    text: 'Promete que hoje vai conseguir controlar a alimentação, mas quando percebe já exagerou nas refeições ou não conseguiu resistir à vontade de comer doces.'
  },
  {
    id: 4,
    icon: 'fa-droplet',
    title: 'Inchaço e retenção',
    text: 'A roupa aperta, o rosto parece mais inchado e você sente que seu corpo está sempre retendo líquido.'
  },
  {
    id: 5,
    icon: 'fa-arrows-rotate',
    title: 'Efeito sanfona',
    text: 'Você perde peso com muito esforço e, pouco tempo depois, ganha tudo de novo.'
  },
  {
    id: 6,
    icon: 'fa-battery-quarter',
    title: 'Cansaço e indisposição',
    text: 'Acorda cansado(a), arrasta o dia sem energia e não tem ânimo nem pra começar uma rotina diferente.'
  }
];

const SymptomsSection = () => {
  return (
    <section id="symptoms" className="mgs-symptoms">
      <div className="mgs-symptoms__inner">
        <div className="mgs-symptoms__top">
          <div className="mgs-symptoms__head">
            <h2 className="mgs-symptoms__title">
              <span className="mgs-symptoms__title-line">Se emagrecer</span>
              <span className="mgs-symptoms__title-line">fosse fácil,</span>
              <span className="mgs-symptoms__title-line mgs-symptoms__title-gold">você não</span>
              <span className="mgs-symptoms__title-line mgs-symptoms__title-gold">estaria aqui.</span>
            </h2>

            <svg className="mgs-symptoms__flourish" viewBox="0 0 150 20" fill="none" aria-hidden="true">
              <path d="M3 15 C 45 3, 105 3, 147 12" stroke="#c1922f" strokeWidth="4" strokeLinecap="round" />
            </svg>

            <span className="mgs-symptoms__pill">Provavelmente você está sentindo:</span>
          </div>

          <div className="mgs-symptoms__photo">
            <img src={IMAGE_PATHS.homemTriste} alt="Pessoa cansada e desanimada" />
          </div>
        </div>

        <div className="mgs-symptoms__list">
          {SYMPTOMS.map((item) => (
            <div key={item.id} className="mgs-symptoms__row">
              <div className="mgs-symptoms__icon">
                <i className={`fas ${item.icon}`}></i>
              </div>
              <div className="mgs-symptoms__row-body">
                <h3 className="mgs-symptoms__row-title">{item.title}</h3>
                <p className="mgs-symptoms__row-text">{item.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SymptomsSection;
